import ko from "knockout";
import "flow/extensions/koMeta";
import { Dictionary } from "flow/api/types";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";
import viewHtml from "./label.html";
import { selectLabel } from "flow/koHelpers/selectParam";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";

export interface ILabelParams {
    attr?: Dictionary;
    for?: KnockoutObservable<any>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    required?: MaybeObservable<boolean>;
}

ko.components.register("ko-label", {
    viewModel: function (params: ILabelParams) {
        this.takeInnerHtml = false;

        if (params.meta || params.text) {
            this.text = selectLabel(params.meta, params.text);
        } else {
            this.takeInnerHtml = true;
        }

        this.required = params.required || false;

        if (params.for) {
            this.required = createRequiredObservable(params.for);
        }

        this.attributes = interceptAttributesWithDefaults({}, params.attr);
    },
    template: viewHtml,
    synchronous: true
});
